import { inject, Injectable } from "@angular/core";
import { DOCUMENT } from '@angular/common';
import { Theme } from "./theme.model";
import { THEMES } from "./theme.const";

@Injectable()
export class ThemeService {
  private readonly document = inject(DOCUMENT); //to avoid usin window.document...
  themeLoaded = false;
  theme: Theme | null = null;
  brandName: string = this.resolveBrandName();
  brandCode: string = this.resolveBrandCode();

  loadTheme(): void {
    const currentHost = window.location.hostname;
    const defaultTheme = THEMES.find((theme: any) => theme.host.includes('default'))!;
    const theme = THEMES.find((theme: any) => theme.host.includes(currentHost) || currentHost.includes(theme.partialHost));

    if (theme) {
      this.theme = {
        ...theme,
        host: currentHost,
      };
      if(this.theme.host === 'localhost' || this.theme.host === "sandaya-dev.guestup.com") {
        this.theme.host = 'sandaya.com';
      }
      // this.setHeadData();
      this.setThemeStyle(this.theme);
      this.setThemeFavicon(this.theme);
    } else {
      console.error(`Loading theme error : Unable to find style for host ${window.location.hostname}`);
      this.theme = {
        ...defaultTheme,
        host: currentHost,
      };

      // this.setHeadData();
      this.setThemeStyle(this.theme);
      this.setThemeFavicon(this.theme);
      console.error(`Default theme has been loaded`);
      // throw `Loading theme error : Unable to find style for host ${window.location.hostname}`;
    }
  }

  setThemeStyle(theme: Theme): void {
    const themeCss = `${theme.name}.css`;
    const head = window.document.getElementsByTagName('head')[0];
    let clientTheme = window.document.getElementById('client-theme') as HTMLLinkElement;

    if (clientTheme) {
      clientTheme.href = themeCss;
    } else {
      const style = window.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = themeCss;
      style.onload = () => {
        this.themeLoaded = true;
      }
      head.appendChild(style);
    }
  }

  private setThemeFavicon(theme: Theme): void {
    const themeFavicon = theme.favicon;
    const linkElement = this.document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    //create link element if not exist
    if (!linkElement) {
      const newLinkElement = this.document.createElement('link');
      newLinkElement.setAttribute('rel', 'icon');
      this.document.head.appendChild(newLinkElement);
    }
    linkElement.setAttribute('href', themeFavicon);
  }

  private resolveBrandName(): string {
    const hostname = window.location.hostname;
    const theme = THEMES.find(t =>
      Array.isArray(t.host) ? t.host.includes(hostname) : t.host === hostname
    ) ?? THEMES.find(t => t.partialHost && hostname.includes(t.partialHost));
    return theme?.name ?? 'default';
  }

  private resolveBrandCode(): string {
    const hostname = window.location.hostname;
    const theme = THEMES.find(t =>
      Array.isArray(t.host) ? t.host.includes(hostname) : t.host === hostname
    ) ?? THEMES.find(t => t.partialHost && hostname.includes(t.partialHost));
    return theme?.brandCode ?? 'SAN';
  }
}